import { parseInt } from "lodash";
import { useEffect, useState } from "react";


const useIdleTimer = (startTime: any) => {
    let interval: any = undefined;
    const [timer, setTimer] = useState(startTime);
    const events = [
        "load",
        "mousemove",
        "mousedown",
        "click",
        "scroll",
        "keypress"
    ];

    useEffect(() => {
        const expiredTime: any = localStorage.getItem("_expiredTime") || 0;
        let expTime = parseInt(expiredTime, 10);
        if (expTime > 0 && expTime < Date.now()) {
            cleanup();
            setTimer(0);
            return;
        }
        else {
            tracker();
            startInterval();
        }
    }, []);

    const updateExpiredTime = () => {
        if (timeoutTracker) {
            clearTimeout(timeoutTracker);
        }

        var timeoutTracker: any = setTimeout(() => {
            localStorage.setItem("_expiredTime", JSON.stringify(Date.now() + startTime * 1000));
        }, 300);
    }

    const tracker = () => {
        for (let i in events) {
            window.addEventListener(events[i], updateExpiredTime);
        }
    }

    const cleanup = () => {
        localStorage.removeItem("_expiredTime");
        clearInterval(interval);
        for (let i in events) {
            window.removeEventListener(events[i], updateExpiredTime);
        }
    }

    const startInterval = () => {
        updateExpiredTime();
        interval = setInterval(() => {
            const expiredTime: any = localStorage.getItem("_expiredTime") || 0;
            let expTime = parseInt(expiredTime, 10);
            if (expTime < Date.now()) {
                cleanup();
                setTimer(0);
            }

        }, 1000);
    }
    return timer;
}

export default useIdleTimer;

